import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { generateRandomHexCode } from "../../../helpers/generateRandomHexCode";
import { getConfigDataByName } from "./getConfigDataByName";
import { inputTypes } from "../../../utils/tableData";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const AverageGraph = ({ surveys }) => {
  const [reArrangedData, setReArrangedData] = useState([]);
  const [labels, setLabels] = useState([]);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top"
      },
      title: {
        display: true,
        text: "compare chart"
      }
    }
  };

  //   const labels = Object.keys(surveys[0]);

  const data = {
    labels,

    datasets: [
      {
        label: "Survey",
        data: reArrangedData,
        backgroundColor: generateRandomHexCode()
      }
    ]
  };
  const reArrangeDataHandler = () => {
    const keys = Object.keys(surveys[0]);
    let tempData = [];
    const tmpLabels = [];
    keys.forEach((key) => {
      if (
        key == "id" ||
        key == "userId" ||
        key == "timestamp" ||
        key == "sessionId"
      ) {
        return;
      }
      let tableItem = getConfigDataByName(key);
      let value = 0;

      if (tableItem?.input?.type != inputTypes.slider) return;
      tmpLabels.push(key);
      surveys.forEach((survey) => {
        value += Number(survey[key]??0);
      });
      tempData.push(value / surveys.length);
    });
    setReArrangedData(tempData);

    console.log(tmpLabels, "tmpLabels");
    setLabels(tmpLabels);
  };
  useEffect(() => {
    reArrangeDataHandler();
  }, [surveys]);
  return (
    <div>
      <div className="w-[500px] h-[300px]">
        <Bar options={options} data={data} />
      </div>
    </div>
  );
};

export default AverageGraph;
